import React, { useCallback, useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import Link from 'components/Link/Link';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import s from './FinancialJargons.scss';
import ImageV2 from '../ImageV2';
import PopupOverlay from '../PopupOverlay/PopupOverlay';

const DETAILS_MAX_LEN = 350;

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <span
      {...props}
      className={`btn next ${className}`}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <i />
    </span>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <span
      {...props}
      className={`btn prev ${className}`}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <i />
    </span>
  );
}

function FinancialJargons({ sectionData, isWapView }) {
  const { name, items, theme, showPopup, seeMoreText, path } = sectionData;
  const popupRef = useRef(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const settings = {
    dots: true,
    slidesToShow: isWapView ? 1 : 3,
    slidesToScroll: isWapView ? 1 : 3,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    infinite: false,
    arrows: !isWapView,
  };

  const handleCardClick = useCallback(
    item => {
      if (showPopup) {
        setSelectedItem(item);
      }
    },
    [showPopup],
  );

  const handleCardKeyDown = useCallback(
    (event, item) => {
      if (!showPopup) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setSelectedItem(item);
      }
    },
    [showPopup],
  );

  const closePopup = useCallback(() => {
    if (popupRef.current && typeof popupRef.current.close === 'function') {
      popupRef.current.close();
    }
  }, []);

  const handlePopupOverlayClose = useCallback(() => {
    setSelectedItem(null);
  }, []);

  useEffect(
    () => {
      if (!showPopup && selectedItem) {
        closePopup();
      }
    },
    [closePopup, selectedItem, showPopup],
  );

  return (
    <div className={`${s.financialJargonsWrap} slick_UI`}>
      <Listingheader headingname={name}>
        {seeMoreText && (
          <Link href={path} className={s.seeMoreText}>
            {seeMoreText}
          </Link>
        )}
      </Listingheader>
      <Slider {...settings}>
        {items &&
          Array.isArray(items) &&
          items.length > 0 &&
          items.map((item, index) => {
            const slideContent = (
              <>
                {item.term && <h2>{item.term}</h2>}
                {item.defination && <p>{item.defination}</p>}
                {item.details && (
                  <p>
                    {item.details.length > DETAILS_MAX_LEN
                      ? `${item.details.slice(0, DETAILS_MAX_LEN)}…`
                      : item.details}{' '}
                    <span className={s.readMore}>Read More</span>
                  </p>
                )}
                {item.name && (
                  <div className={s.authorRow}>
                    <div className={s.authorNameCol}>
                      {item.name && (
                        <span className={s.authorName}>{item.name}</span>
                      )}
                    </div>
                    {item.image_msid && (
                      <div className={s.authorImageCol}>
                        <ImageV2
                          className={s.authorImage}
                          msid={item.image_msid}
                          width={48}
                          height={48}
                          altTitle={item.name || 'Author'}
                          lazyload
                        />
                      </div>
                    )}
                  </div>
                )}
              </>
            );

            return (
              <div className={s.financialJargons} key={index}>
                {showPopup ? (
                  <div
                    className={`${s.financialJargonsSlide} ${s[theme]} ${
                      s.popupEnabled
                    }`}
                    onClick={() => handleCardClick(item)}
                    onKeyDown={event => handleCardKeyDown(event, item)}
                    role="button"
                    tabIndex={0}
                    aria-label={`Open ${item.term || 'details'}`}
                  >
                    {slideContent}
                  </div>
                ) : (
                  <div className={`${s.financialJargonsSlide} ${s[theme]}`}>
                    {slideContent}
                  </div>
                )}
              </div>
            );
          })}
      </Slider>
      {selectedItem && (
        <PopupOverlay
          ref={popupRef}
          position={isWapView ? 'bottom' : 'center'}
          closeCallback={handlePopupOverlayClose}
          show
          noGap
          maxHeight={!isWapView}
          enableClose
        >
          <div className={s.financialJargonsPopup}>
            <div className={s.popupScrollArea}>
              <div className={s.popupBodyCol}>
                <div className={s.popupBodyColContent}>
                  {selectedItem.term && (
                    <h2 className={s.popupTitle}>{selectedItem.term}</h2>
                  )}
                  {selectedItem.defination && (
                    <p className={s.popupDefinition}>
                      {selectedItem.defination}
                    </p>
                  )}
                  {selectedItem.details && (
                    <div className={s.popupSyn}>
                      <p>{selectedItem.details}</p>
                    </div>
                  )}
                  {selectedItem.name && (
                    <div className={s.popupAuthorRow}>
                      <div className={s.popupAuthorNameCol}>
                        <span className={s.popupAuthorName}>
                          {selectedItem.name}
                        </span>
                      </div>
                      {selectedItem.image_msid && (
                        <div className={s.popupAuthorImageCol}>
                          <ImageV2
                            className={s.popupAuthorImage}
                            msid={selectedItem.image_msid}
                            width={48}
                            height={48}
                            altTitle={selectedItem.name || 'Author'}
                            lazyload
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </PopupOverlay>
      )}
    </div>
  );
}

export default FinancialJargons;
